import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Box,
  Button,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { apiService } from "../../../api/apiService"; // Import the common apiService
import StrategyStyle from "../../../Views/Strategy/Strategyandvaluecreation/strategy.module.css";
import SuccessPopup from "../Popup/Success&ErrorPopup/SuccessPopup";
import ErrorPopup from "../Popup/Success&ErrorPopup/ErrorPopup";

interface CustomDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  // onSave: () => void;
  management: string;
  section_name: string;
  // fetchData: () => void; // Add fetchData prop
  openUpload: boolean;
  setOpenUpload: Dispatch<SetStateAction<boolean>>;
  onSuccess?: () => void;


}

const CustomDialog: React.FC<CustomDialogProps> = ({
  open,
  onClose,
  title,
  management,
  section_name,
  openUpload,
  setOpenUpload,
  onSuccess
}) => {
  const { instance } = useMsal(); 
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [formData, setFormData] = useState({
    BSC_Mission: "",
    BSC_long_term_objective: "",
    KPI_name: "",
    UoM: "",
    currentstatus: "",
    north_star: 0,
    north_star_value: "",
    target_year: 2025,
    target_year_value: "",
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSave = async () => {
    setIsLoading(true);
    try {
      const payload = {
        management,
        section_name,
        ...formData,
      };
  
      await apiService("/strategy/vision_n_strategy", "POST", payload, undefined, instance as PublicClientApplication);
      setOpenUpload(false);
      setShowSuccess(true);
  
      if (onSuccess) {
        onSuccess(); // Ensure this is called

      }
      onClose(); // Close the dialog
    } catch (error) {
      console.error("Failed to save Vision N Strategy:", error);
      setErrorMessage("Failed to save Vision N Strategy");
      setShowError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (showSuccess) {
      timer = setTimeout(() => {
        setShowSuccess(false);
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [showSuccess]);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (showError) {
      timer = setTimeout(() => {
        setShowError(false);
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [showError]);

  return (
    <>
      <Dialog onClose={onClose} open={open}>
        <Box sx={{ minWidth: '600px' }}>
          <DialogTitle sx={{ m: 0, p: 2, color: '#000' }}>{title}</DialogTitle>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={(theme) => ({
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent dividers>
            <Box>
              <div className="m-0">
                <label>KPI name *</label>
                <input
                  name="KPI_name"
                  placeholder="Enter the KPI Name"
                  value={formData.KPI_name}
                  onChange={handleInputChange}
                  className={StrategyStyle.inputFeild}
                />
              </div>
              <div className="m-1">
                <label>UOM *</label>
                <input
                  name="UoM"
                  placeholder="Enter the UOM (Unit of Measure)"
                  value={formData.UoM}
                  onChange={handleInputChange}
                  className={StrategyStyle.inputFeild}
                />
              </div>
              <div className="m-1">
                <label>Current Status *</label>
                <input
                  name="currentstatus"
                  placeholder="Enter the Current Status"
                  value={formData.currentstatus}
                  onChange={handleInputChange}
                  className={StrategyStyle.inputFeild}
                />
              </div>
              <div className="m-1">
                <label>Target Year *</label>
                <div className={StrategyStyle.inlineform}>
                  <Typography className={StrategyStyle.inputFeild} sx={{ padding: '8px', border: '1px solid #000', borderRadius: '4px' }}>
                    2025
                  </Typography>
                  <input
                    name="target_year_value"
                    placeholder="Enter the Target Year Details"
                    value={formData.target_year_value}
                    onChange={handleInputChange}
                    className={StrategyStyle.inputFeild}
                  />
                </div>
              </div>
              <div className="m-1">
                <label>North Star*</label>
                <div className={StrategyStyle.inlineform}>
                  <select
                    name="north_star"
                    value={formData.north_star}
                    onChange={handleInputChange}
                    className={StrategyStyle.inputFeild}
                  >
                    <option value={0}>Select Year</option>
                    <option value={2030}>2030</option>
                    <option value={2035}>2035</option>
                    <option value={2040}>2040</option>
                  </select>
                  <input
                    name="north_star_value"
                    placeholder="What is the long term KPI value you want to achieve?"
                    value={formData.north_star_value}
                    onChange={handleInputChange}
                    className={StrategyStyle.inputFeild}
                  />
                </div>
              </div>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" autoFocus onClick={onClose} sx={{ color: '#000', borderColor: '#000' }}>Cancel</Button>
            <Button variant="contained" autoFocus onClick={handleSave} sx={{ background: '#000', color: '#fff' }} disabled={isLoading}> {isLoading ? "Loading..." : "Save KPI"}</Button>
          </DialogActions>
        </Box>
      </Dialog>

      <SuccessPopup
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        message="BSC Mission KPIs uploaded successfully!"
      />

      <ErrorPopup
        open={showError}
        onClose={() => setShowError(false)}
        message={errorMessage}
      />
    </>
  );
};

export default CustomDialog;